import React, { Component } from "react";
import { CommonValidationMessages } from "../../utils/Messages.js";
import { isValidForm } from "../../utils/validation/CommonValidator.js";
import ValidationText from "../../utils/validation/ValidationText.js";
import SwalServices from "../../services/swalServices/SwalServices.js";
import CommonServices from "../../services/axioServices/apiServices/CommonServices.js";
import ItemMasterServices from "../../services/axioServices/apiServices/ItemMasterServices.js";
import ProductionServices from "../../services/axioServices/apiServices/ProductionServices.js";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSpinner, faTrash } from "@fortawesome/free-solid-svg-icons";
import MultiSelectDropdown from "../../components/dropdown/MultiSelectDropdown.js";
import { getAuthProps } from "../../utils/AuthenticationLibrary.js";
import { printFunction } from "../../components/print/printTemplate.js";

class MaterialRequirmentReportPM extends Component {
  constructor(props) {
    super(props);
    this.productionServices = new ProductionServices();
    this.itemMasterServices = new ItemMasterServices();
    this.commonServices = new CommonServices();
    this.SwalServices = new SwalServices();
    this.state = {
      companyName: '',
      onlyShortageItems: false,
      productWithBatchSizeList: [],
      materialRequirementReportPMList: [],
      companyItemList: [],
      isLoading: false,
      tableStatus: "",
      filterDetails: {
        packingId: "",
        batchSize: "",
        packingMaterialname: "",
      },
      validationRules: {
        packingId: [
          {
            type: "require",
            message: CommonValidationMessages.SelectRequired.replace(
              "{0}",
              "product name"
            ),
          },
        ],
        batchSize: [
          {
            type: "require",
            message: CommonValidationMessages.FieldRequired.replace(
              "{0}",
              "batch size"
            ),
          },
        ],
      },
      validState: {
        isValid: true,
        error: {},
      },
    };
  }

  componentDidMount() {
    this.getAllItem();
    const company = getAuthProps()
    this.setState({ companyName: company?.companyName })
  }

  getAllItem = () => {
    this.commonServices.getAllItem().then((response) => {
      if (response.statusCode === 200 && response.responseData != null) {
        let res = response.responseData;
        let dropdownItems = res.map((item) => ({
          label: item.ItemName,
          value: item._id,
          packing: item.Packing,
        }));

        this.setState({ companyItemList: dropdownItems });
      } else {
        this.SwalServices.Error(response.Message);
      }
    });
  };

  addEditPackingMaterial = () => {
    let isValidAllFields = this.isValidAllFields();
    if (isValidAllFields) {
      let details = this.state.filterDetails;
      let array = this.state.productWithBatchSizeList;
      array.push({
        packingId: details.packingId,
        packingMaterialname: details.packingMaterialname,
        batchSize: details.batchSize,
      });

      this.setState({ productWithBatchSizeList: array }, () => {
        this.resetProductForm();
      });
    }
  };

  resetProductForm = () => {
    let details = this.state.filterDetails;
    details.batchSize = "";
    details.packingId = "";
    details.packingMaterialname = "";
    this.setState({ filterDetails: details });
  };

  resetForm = () => {
    let validState = this.state.validState;
    validState.isValid = true;
    validState.error = {};
    let details = this.state.filterDetails;
    details.batchSize = "";
    details.productId = "";
    details.productName = "";
    this.setState({ productWithBatchSizeList: [], validState: validState, filterDetails: details, materialRequirementReportPMList: [], onlyShortageItems: false, tableStatus: false });
  }

  setFilterParameters = (selected, drpIdentity) => {
    let details = this.state.filterDetails;
    details[drpIdentity] = selected.value;
    details.packingMaterialname = selected.label;
    this.setState({ filterDetails: details });
  };

  handleChange = (event, name, section) => {
    let value = event.target.value;
    let details = this.state.filterDetails;
    details[name] = value.toUpperCase();
    this.setState({ filterDetails: details });
  };

  isValidAllFields = () => {
    const newValidState = isValidForm(
      this.state.filterDetails,
      this.state.validationRules,
      this.state.validState
    );
    this.setState({ validState: newValidState });
    return newValidState.isValid;
  };

  deleteRecordById = (id) => {
    let updatedList = this.state.productWithBatchSizeList.filter(
      (item) => item.productId !== id
    );
    this.setState({ productWithBatchSizeList: updatedList });
  };

  handleChangeCheckbox = (event) => {
    let value = event.target.checked;
    this.setState({ onlyShortageItems: value }, () => {
      if (this.state.onlyShortageItems === true) {
        let list = this.state.materialRequirementReportPMList;
        list = list.filter((item) => item.reqQty > 0);
        this.setState({ materialRequirementReportPMList: list });
      } else {
        this.getAllMaterialRequirementReportForPM();
      }
    });
  };

  getAllMaterialRequirementReportForPM = () => {
    this.setState({ isLoading: true, tableStatus: "Loading..." }, () => {
      let request = this.state.productWithBatchSizeList;
      this.productionServices
        .getAllMaterialRequirementReportForPM(request)
        .then((response) => {
          if (response.statusCode === 200 && response.responseData != null) {
            if (response.responseData.length === 0) {
              this.setState({ tableStatus: "No Record Found" })
            } else {
              this.setState({ tableStatus: "" })
            }
            let res = response.responseData;
            res.map((item) => {
              item.uom = item.pmUOM ? item.pmUOM : item.uom;
              item.qty = Number(item.qty).toFixed(2);
              item.reqQty =
                Number(item.qty) - Number(item.totalStock) > 0
                  ? (Number(item.qty) - Number(item.totalStock)).toFixed(2)
                  : 0;
              item.stock = item.totalStock.toFixed(2);
            });
            this.setState({ materialRequirementReportPMList: res, isLoading: false });
          } else {
            this.setState({ tableStatus: "", isLoading: false })
            this.SwalServices.Error(response.Message);
          }
        });
    })
  };

  render() {
    return (
      <div className="materialRequirmentReportPM-page">
        {/* 1. Item search */}
        <div className="item-search w-[60%] flex gap-[10px] mb-4">
          <div className="search-grp w-[60%]">
            <label>Product Name</label>
            <MultiSelectDropdown
              drpIdentity="packingId"
              className={` ${this.state.validState?.error?.packingId ? "errorInput" : ""}`}
              options={this.state.companyItemList}
              closeMenuOnSelect={true}
              hideSelectedOptions={false}
              onChange={(selected) =>
                this.setFilterParameters(selected, "packingId", "filterDetails")
              }
              allowSelectAll={false}
              value={this.state.companyItemList.filter(
                (product) =>
                  product.value === this.state.filterDetails.packingId
              )}
            />
            {/* <ValidationText error={this.state.validState.error.packingId} /> */}
          </div>
          <div className="search-grp w-[40%]">
            <label>Batch Size</label>
            <input
              type="text"
              id="batchSize"
              name="batchSize"
              autoComplete="off"
              className={`inputFocus ${this.state.validState?.error?.batchSize ? "errorInput" : ""}`}
              value={this.state.filterDetails.batchSize}
              onChange={(event) =>
                this.handleChange(event, "batchSize", "filterDetails")
              }
            />
            {/* <ValidationText error={this.state.validState.error.batchSize} /> */}
          </div>
          <button
            className="add-btn mt-[20px] h-fit"
            onClick={() => this.addEditPackingMaterial()}
          >
            Add
          </button>
          <button
            className="cancel-btn mt-[20px] h-fit"
            onClick={() => this.resetForm()}
          >
            Cancel
          </button>
        </div>

        {/* 2. Item tabel  */}
        <div className="itemList-table w-[60%]">
          <div className="table-container h-[23vh]">
            <table className="itemList">
              <thead>
                <tr>
                  <td className="w-[10%]">Sr</td>
                  <td className="w-[40%]">Product Name</td>
                  <td className="w-[30%]">Batch Size</td>
                  <td className="w-[20%]" style={{ textAlign: "center" }}>Action</td>
                </tr>
              </thead>
              <tbody>
                {this.state.productWithBatchSizeList &&
                  this.state.productWithBatchSizeList.length > 0
                  ? this.state.productWithBatchSizeList.map((item, key) => (
                    <tr key={key}>
                      <td>{key + 1}</td>
                      <td>{item.packingMaterialname}</td>
                      <td>{item.batchSize}</td>
                      <td style={{ textAlign: "center" }}>
                        <button
                          className="cancel-btn"
                          onClick={() =>
                            this.deleteRecordById(item.productId)
                          }
                        >
                          <FontAwesomeIcon icon={faTrash} />
                        </button>
                      </td>
                    </tr>
                  ))
                  : null}
              </tbody>
            </table>
          </div>
        </div>

        {/* 3. Button  */}
        <div className="mt-3.5 mb-3.5 flex gap-2.5">

          {this.state.productWithBatchSizeList.length > 0 ? (
            <button
              onClick={() => this.getAllMaterialRequirementReportForPM()}
              className="search-btn"
              disabled={this.state.isLoading}
            >
              {this.state.isLoading ? <FontAwesomeIcon icon={faSpinner} className="loader" /> : "Search"}
            </button>
          ) : null}
          {this.state.materialRequirementReportPMList.length > 0 ? (
            <button
              className="print-btn mt-auto"
              onClick={() => printFunction()}
            >
              Print
            </button>
          ) : null}
          {this.state.materialRequirementReportPMList.length > 0 ? (
            <div className="search-grp flex justify-start items-center gap-2.5 ml-2.5">
              <label>Only Shortage Items </label>
              <input
                type="checkbox"
                id="onlyShortageItems"
                name="onlyShortageItems"
                className="inputFocus w-[16px] h-[16px]"
                value={this.state.onlyShortageItems}
                checked={this.state.onlyShortageItems}
                onChange={(event) => this.handleChangeCheckbox(event)}
              />
            </div>
          ) : null}
          {/* <button className="cancel-btn mt-auto !ml-2.5">cancel</button> */}
        </div>

        {/* 4. Item Table  */}
        <div className="itemList-table">
          <div className="hidden print-title">
            <h4>Packing Material Requirment Report</h4>

          </div>
          <div className="table-container h-[50vh]">
            <table className="itemList">
              <thead>
                <tr>
                  <td className="w-[40%]">Item Name</td>
                  <td className="w-[15%]">Quantity</td>
                  <td className="w-[15%]">UOM</td>
                  <td className="w-[15%]">Total Available</td>
                  <td className="w-[15%]">Required Quantity</td>
                </tr>
              </thead>
              <tbody>
                {this.state.materialRequirementReportPMList &&
                  this.state.materialRequirementReportPMList.length > 0
                  ? this.state.materialRequirementReportPMList.map(
                    (item, key) => (
                      <tr key={key} className={`${Number(item.reqQty) > 0 ? "text-red-600" : ""}`}>
                        <td>{item.pmName}</td>
                        <td>{Number(item.netQty) ? Number(item.netQty).toFixed(2) : 0}</td>
                        <td>{item.uom}</td>
                        <td>{Number(item.stock) ? Number(item.stock).toFixed(2) : 0}</td>
                        <td>{Number(item.reqQty) ? Number(item.reqQty).toFixed(2) : 0}</td>
                      </tr>
                    )
                  )
                  : this.state.materialRequirementReportPMList &&
                    this.state.materialRequirementReportPMList.length === 0
                    && this.state.tableStatus !== "" ? (
                    <tr>
                      <td colSpan={5} style={{ textAlign: "center", fontSize: "16px" }}>
                        {this.state.tableStatus}
                      </td>
                    </tr>
                  ) : this.state.materialRequirementReportPMList &&
                    this.state.materialRequirementReportPMList.length === 0
                    && this.state.tableStatus === "" ? null : ""}
              </tbody>
            </table>
          </div>
        </div>

        {/*----- Print layout -----*/}
        <div className='table-print mt-5 hidden' id="printableArea">
          {/* Header */}
          <div className="print-header">
            <table className="hdr-table">
              <tbody>
                <tr>
                  <td>
                    <div className="co-name">{this.state.companyName}</div>
                    <div className="rpt-sub">Material Requirment Report [PM]</div>
                  </td>
                </tr>
              </tbody>
            </table>

            <div className="rule-thick" />
            <div className="rule-thin" />
          </div>


          <div className="print-content">

            {/* <div className="info-row">
                                              <div>
                                                <span className="info-label">Item Name:</span>
                                                <p className="info-value">Paracetamol</p>
                                              </div>
                                            </div> */}

            {/* Table */}
            <table className="data-tbl">
              <colgroup>
                <col style={{ width: "28%" }} />
                <col style={{ width: "18%" }} />
                <col style={{ width: "18%" }} />
                <col style={{ width: "18%" }} />
                <col style={{ width: "18%" }} />
              </colgroup>

              <thead>
                <tr>
                  <th style={{ textAlign: 'left' }}>
                    Item Name
                  </th>
                  <th style={{ textAlign: 'center' }}>
                    Quantity
                  </th>
                  <th style={{ textAlign: 'center' }}>
                    UOM
                  </th>
                  <th style={{ textAlign: 'center' }}>
                    Total Available
                  </th>
                  <th style={{ textAlign: 'center' }}>
                    Required Qty
                  </th>
                </tr>
              </thead>

              <tbody>
                {this.state.materialRequirementReportPMList &&
                  this.state.materialRequirementReportPMList.length > 0
                  ? this.state.materialRequirementReportPMList.map(
                    (item, key) => (
                      <tr key={key}>
                        <td style={{ textAlign: 'left' }}>
                          {item.pmName}
                        </td>
                        <td style={{ textAlign: 'center' }}>
                          {Number(item.netQty) ? Number(item.netQty).toFixed(2) : 0}
                        </td>
                        <td style={{ textAlign: 'center' }}>
                          {item.uom}
                        </td>
                        <td style={{ textAlign: 'center' }}>
                          {Number(item.stock) ? Number(item.stock).toFixed(2) : 0}
                        </td>
                        <td style={{ textAlign: 'center' }}>
                          {Number(item.reqQty) ? Number(item.reqQty).toFixed(2) : 0}
                        </td>
                      </tr>
                    )) : (
                    <tr>
                      <td colSpan="5" style={{ textAlign: 'center' }}>
                        No Data Found
                      </td>
                    </tr>
                  )}
              </tbody>
            </table>
          </div>

          {/* Footer */}
          <div className="print-footer">
            <div className="rule-foot">
              <table className="foot-tbl">
                <tbody>
                  <tr>
                    <td>* System generated report. No signature required.</td>
                    <td style={{ textAlign: "right" }}>
                      Printed: {new Date().toLocaleDateString("en-GB")} {new Date().toLocaleTimeString("en-GB", { hour: "2-digit", minute: "2-digit" })}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

        </div>
      </div>
    );
  }
}

export default MaterialRequirmentReportPM;
